var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/settings.27cf892d.png","uri@2x": __webpack_public_path__ + "static/media/settings.f7049729.png","uri@3x": __webpack_public_path__ + "static/media/settings.cfe4b8c9.png",
    width: 40,
    height: 40
});